import { PageHeader } from '@/components/layout/PageHeader';
import { RTPDownloadBuilder } from '@/components/features/rtp-download/RTPDownloadBuilder';

export function DoctorRTPDownload() {
  return (
    <div>
      <PageHeader
        title="Download RTP Data"
        description="Select patients and configure time range to download RTP sensor data"
      />

      <RTPDownloadBuilder />
    </div>
  );
}
